import React, {useRef} from 'react';
import {usePlayersListSideMenu} from '../../contexts/PlayersListSideMenuContext';
import {usePolicyMarketSideMenu} from '../../contexts/PolicyMarketSideMenuContext';
import {useDesktopLayout} from '../../hooks/visuals/useWideScreenLayout';
import {joinClassNames} from '../gameUi/joinClassNames';
import {isMatchToastsPaused, MatchToastsPausedContext} from './matchToastsPause';
import {useToastsBottomEdge} from './useToastsBottomEdge';

/**
 * Стек уведомлений матча (тосты, покупка политики, реакции) — один
 * fixed-контейнер, внутри которого уведомления обычные flow-элементы (стили —
 * .toast-stack в GameContent.css). Стоит в левом нижнем углу над кнопками
 * чата, реакций и слоев поля (а если их панель развернута — над ней; замер
 * useToastsBottomEdge) и растет вверх: там поле обычно пустое, а шапка,
 * плашка ходящего и центр поля остаются открытыми.
 * - Десктоп: при открытом рынке политик (он слева) стек сдвигается правее
 *   него.
 * - Телефон: правый край стека не доходит до колонки кнопки хода. Пока открыт
 *   список игроков или рынок (лист снизу), уведомления на паузе: их не
 *   видно, время и звук ждут (MatchToastsPausedContext).
 * Сам стек на паузе не прячется: внутри живет модалка мута реакции
 */
const MatchToastStack = ({children}) => {
  const isDesktopLayout = useDesktopLayout();
  const {isMenuOpen: isPlayersListOpen} = usePlayersListSideMenu();
  const {isMenuOpen: isPolicyMarketOpen} = usePolicyMarketSideMenu();
  const isPaused = isMatchToastsPaused({isDesktopLayout, isPlayersListOpen, isPolicyMarketOpen});
  const stackRef = useRef(null);
  const bottomEdge = useToastsBottomEdge(stackRef, isDesktopLayout);

  return (
    <MatchToastsPausedContext.Provider value={isPaused}>
      <div
        ref={stackRef}
        className={joinClassNames(
          'toast-stack',
          isDesktopLayout && isPolicyMarketOpen && 'toast-stack_market-open',
        )}
        style={bottomEdge !== null ? {'--toasts-bottom-edge': `${bottomEdge}px`} : undefined}
      >
        {children}
      </div>
    </MatchToastsPausedContext.Provider>
  );
};

export default MatchToastStack;
